import React, { useState } from 'react'
import { Field, Form, Formik, useFormikContext } from 'formik'
import {
  Button,
  Card,
  Columns,
  Element,
  Image,
  Modal,
  Form as BulmaForm,
  Icon,
} from 'react-bulma-components'
import InputField from '../form/fields/input'
import { useSerialNumbersFamiliesQuery } from '../../queries'
import SelectField from '../form/fields/select'
import { countriesAsSelectioOptions } from '../../constants/countries'
// @ts-expect-error
import serialNumberImg from '../../assets/images/serial-number-with-highlight.png'
import { Translate, translate } from '../../utils/translations'
import { useTranslations } from '../../hooks/use-translations'
import { BiSearch } from 'react-icons/bi'
import FormikObserver from '../form/formik-observer'
import { checkStatusDataCreationPayload } from '../../../../backend/src/services/product-items/product-items.schema'

export interface CheckStatusFormProps {
  onSubmit(values: checkStatusDataCreationPayload): void
  serialNumberValidation: 'unknown' | 'good' | 'defective' | undefined
  onFormChange(values: Partial<checkStatusDataCreationPayload>): void
}

const initialValues = {
  requestor: { firstName: '', lastName: '', email: '', phone: '', country: '' },
  serialNumberFamily: '',
  serialNumber: '',
}

if (process.env.NODE_ENV === 'developmenat') {
  initialValues.requestor.firstName = 'Jean'
  initialValues.requestor.lastName = 'Dupuis'
  initialValues.requestor.email = 'j.dupuis@example.com'
  initialValues.requestor.phone = '0123456789'
  initialValues.requestor.country = 'BE'
  initialValues.serialNumberFamily = '010358378766260121000000'
  initialValues.serialNumber = '660002'
}

const CheckStatusForm: React.FC<CheckStatusFormProps> = ({
  onSubmit,
  serialNumberValidation,
  onFormChange,
}) => {
  const serialNumbersFamiliesQuery = useSerialNumbersFamiliesQuery()
  const [showModal, setShowModal] = useState(false)

  const ERRORS = {
    REQUIRED_FIELD: translate('home.form.errors.requiredField'),
    UNKNOWN_SERIAL_NUMBER: translate('home.form.errors.unknownSerialNumber'),
    PROVIDE_6_NUMBERS: translate('home.form.errors.provide6Numbers'),
  }

  const { current: currentLocale } = useTranslations()
  console.log(translate('home.form.fields.choose'))
  return (
    <Formik
      initialValues={initialValues}
      validate={values => {
        const errors: any = {}
        const requestor = values.requestor || {}
        if (!requestor.firstName) errors['requestor.firstName'] = ERRORS.REQUIRED_FIELD
        if (!requestor.lastName) errors['requestor.lastName'] = ERRORS.REQUIRED_FIELD
        if (!requestor.email || !requestor.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,12}$/))
          errors['requestor.email'] = ERRORS.REQUIRED_FIELD
        if (!requestor.country) errors['requestor.country'] = ERRORS.REQUIRED_FIELD
        if (!values.serialNumber) errors.serialNumber = ERRORS.REQUIRED_FIELD
        else if (values.serialNumber.length !== 6) errors.serialNumber = ERRORS.PROVIDE_6_NUMBERS
        if (!values.serialNumberFamily) errors.serialNumberFamily = ERRORS.REQUIRED_FIELD
        //TODO: serial number family
        return errors
      }}
      onSubmit={values => {
        onSubmit({
          ...values,
          serialNumber: { complete: `${values.serialNumberFamily}${values.serialNumber}` },
          requestor: {
            ...values.requestor,
            language: currentLocale!,
          },
        })
      }}
    >
      {props => (
        <Form noValidate>
          <FormikObserver values={props.values} onChange={values => onFormChange(values)} />
          <Columns centered>
            <Columns.Column tablet={{ size: 12 }} desktop={{ size: 12 }} widescreen={{ size: 8 }}>
              <Card>
                <Card.Content>
                  <Field
                    name="requestor.firstName"
                    label={translate('home.form.fields.firstName')}
                    component={InputField}
                  />
                  <Field
                    name="requestor.lastName"
                    label={translate('home.form.fields.lastName')}
                    component={InputField}
                  />

                  <Field
                    name="requestor.email"
                    label={translate('home.form.fields.email')}
                    component={InputField}
                    type="email"
                  />
                  <Field
                    name="requestor.phone"
                    label={translate('home.form.fields.phone')}
                    type="tel"
                    component={InputField}
                  />
                  <Field
                    name="requestor.country"
                    label={translate('home.form.fields.country')}
                    type="tel"
                    component={SelectField}
                    options={countriesAsSelectioOptions}
                    selectDefaultChooseOptionLabel={translate('home.form.fields.choose')}
                  />
                  <Button
                    color="ghost"
                    onClick={() => setShowModal(true)}
                    type="button"
                    textWeight="normal"
                    className="is-small-mobile"
                    mt={5}
                  >
                    <Icon text>
                      <Icon>
                        <BiSearch />
                      </Icon>
                      <u>
                        <Translate value="home.findTheSerialNumber.title" />
                      </u>
                    </Icon>
                  </Button>
                  <Element backgroundColor="primary-light" p={3}>
                    <BulmaForm.Label textSize={5}>
                      {translate('home.form.fields.serialNumber')}&nbsp;&nbsp;&nbsp;
                    </BulmaForm.Label>
                    <Columns>
                      <Columns.Column narrow>
                        <BulmaForm.Field kind="group">
                          <BulmaForm.Control>
                            <DisabledAutoSizedField>(01)035837876626</DisabledAutoSizedField>
                          </BulmaForm.Control>
                          <BulmaForm.Control>
                            <Field
                              name="serialNumberFamily"
                              component={SelectField}
                              selectDefaultChooseOptionLabel={translate('home.form.fields.choose')}
                              options={(serialNumbersFamiliesQuery.data || []).map(value => ({
                                value,
                                label: value.substring(14, 16),
                              }))}
                              textColor="primary"
                              textWeight="bold"
                              className="is-small-mobile"
                              color="primary"
                            />
                          </BulmaForm.Control>
                        </BulmaForm.Field>
                      </Columns.Column>
                      <Columns.Column>
                        <BulmaForm.Field>
                          <BulmaForm.Field kind="group">
                            <BulmaForm.Control>
                              <DisabledAutoSizedField>(21)000000</DisabledAutoSizedField>
                            </BulmaForm.Control>
                            <BulmaForm.Control
                              className="is-small-mobile"
                              style={{ flexShrink: 1 }}
                            >
                              <Field
                                name="serialNumber"
                                component={InputField}
                                minLength={6}
                                maxLength={6}
                                size={6}
                                textColor="primary"
                                textWeight="bold"
                                placeholder="- - - - - -"
                                className="is-small-mobile"
                                color="primary"
                              />
                              {/*<BulmaForm.Help className="mt-0">
                              {ERRORS.PROVIDE_6_NUMBERS}
                          </BulmaForm.Help>*/}
                            </BulmaForm.Control>
                          </BulmaForm.Field>
                        </BulmaForm.Field>
                      </Columns.Column>
                    </Columns>
                    {/* <Image src={serialNumberHighlighted} style={{ maxWidth: 800 }} /> */}
                    <SerialNumberValidationObserver
                      serialNumberValidation={serialNumberValidation}
                      error={ERRORS.UNKNOWN_SERIAL_NUMBER}
                    />
                  </Element>
                  <Button
                    fullwidth
                    color="primary"
                    style={{ marginTop: 'auto' }}
                    textWeight="bold"
                    mt={4}
                    type="submit"
                  >
                    <Translate value="home.form.fields.submit" />
                  </Button>
                </Card.Content>
              </Card>
            </Columns.Column>
          </Columns>
          <FindSerialNumberModal show={showModal} onClose={() => setShowModal(false)} />
        </Form>
      )}
    </Formik>
  )
}

export default CheckStatusForm

const FindSerialNumberModal: React.FC<{ show: boolean; onClose: () => void }> = ({
  show,
  onClose,
}) => {
  return (
    <Modal closeOnBlur closeOnEsc showClose show={show} onClose={onClose}>
      <Modal.Card>
        <Modal.Card.Header backgroundColor="white" style={{ borderBottom: 'none' }}>
          <Modal.Card.Title mobile={{ textSize: 6 }}>
            <Translate value="home.findTheSerialNumber.title" />
          </Modal.Card.Title>
        </Modal.Card.Header>
        <Modal.Card.Body style={{ paddingTop: 0 }}>
          <Element renderAs="p" mb={4}>
            <Translate value="home.findTheSerialNumber.description" />
          </Element>
          <Image src={serialNumberImg} style={{ maxWidth: 800, margin: '0 auto' }} />
        </Modal.Card.Body>
      </Modal.Card>
    </Modal>
  )
}

const DisabledAutoSizedField: React.FC<{
  children?: React.ReactNode
  loading?: boolean
}> = ({ children, ...rest }) => {
  return (
    <Button disabled onClick={() => undefined} type="button" className="is-small-mobile" {...rest}>
      {children}
    </Button>
  )
}
const SerialNumberValidationObserver = ({
  serialNumberValidation,
  error,
}: {
  serialNumberValidation: CheckStatusFormProps['serialNumberValidation']
  error: string
}) => {
  const { setFieldError, errors } = useFormikContext()

  if (serialNumberValidation === 'unknown') {
    !errors['serialNumber'] && setFieldError('serialNumber', error)
    !errors['serialNumberFamily'] && setFieldError('serialNumberFamily', error)
  }
  return <></>
}
